
export const statusArr = [
    {
        value: ' ',
        label: '全部',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '4',
                label: '犹退件'
            },
            {
                value: '5',
                label: '停效件'
            },
            {
                value: '6',
                label: '失效件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '11',
                label: '豁免件'
            },
            {
               value: '13',
               label: '退保件'
            }
        ]
    },{
        value: 'false',
        label: '新保',
        children:  [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '4',
                label: '犹退件'
            },
            {
                value: '5',
                label: '停效件'
            },
            {
                value: '6',
                label: '失效件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '11',
                label: '豁免件'
            },
            {
                value: '13',
                label: '退保件'
            }
        ]
    },{
        value: 'true',
        label: '续保',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '4',
                label: '犹退件'
            },
            {
                value: '5',
                label: '停效件'
            },
            {
                value: '6',
                label: '失效件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '11',
                label: '豁免件'
            },
            {
                value: '13',
                label: '退保件'
            }
        ]
    }
]
export const statusArrCar = [
    {
        value: ' ',
        label: '全部',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '投保件'
            },
            {
                value: '4',
                label: '退保件'
            },
            {
                value: '7',
                label: '到期件'
            }
        ]
    },{
        value: 'false',
        label: '新保',
        children:  [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '投保件'
            },
            {
                value: '4',
                label: '退保件'
            },
            {
                value: '7',
                label: '到期件'
            }
        ]
    },{
        value: 'true',
        label: '续保',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '投保件'
            },
            {
                value: '4',
                label: '退保件'
            },
            {
                value: '7',
                label: '到期件'
            }
        ]
    }
]
export const statusArrNoCar = [
    {
        value: ' ',
        label: '全部',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '13',
                label: '退保件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '12',
                label: '逾退件'
            },
        ]
    },{
        value: 'false',
        label: '新保',
        children:  [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '13',
                label: '退保件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '12',
                label: '逾退件'
            },
        ]
    },{
        value: 'true',
        label: '续保',
        children: [
            {
                value: ' ',
                label: '全部'
            },
            {
                value: '1',
                label: '未完成'
            },
            {
                value: '2',
                label: '承保件'
            },
            {
                value: '3',
                label: '预收件'
            },
            {
                value: '13',
                label: '退保件'
            },
            {
                value: '7',
                label: '终止件'
            },
            {
                value: '10',
                label: '宽限件'
            },
            {
                value: '12',
                label: '逾退件'
            },
        ]
    }
]
export const  useNatureList =[
	{
		name:'非营运',
		value:'A'
	},
	{
		name:'公路客运',
		value:'B'
	},
	{
		name:'公交客运',
		value:'C'
	},
	{
		name:'出租客运',
		value:'D'
	},
	{
		name:'旅游客运',
		value:'E'
	},
	{
		name:'货运',
		value:'F'
	},
	{
		name:'租赁',
		value:'G'
	},
	{
		name:'警用',
		value:'H'
	},
	{
		name:'消防',
		value:'I'
	},
	{
		name:'救护',
		value:'J'
	},
	{
		name:'工程救险',
		value:'K'
	},
	{
		name:'营转非',
		value:'L'
	},
	{
		name:'出租转非',
		value:'M'
	},
	{
		name:'教练',
		value:'N'
	},
	{
		name:'幼儿校车',
		value:'O'
	},
	{
		name:'小学生校车',
		value:'P'
	},
	{
		name:'其他校车',
		value:'Q'
	},
	{
		name:'危化品运输',
		value:'R'
	}
]

// 通用签约公司列表
export const commonSignCompanyList=[
    {
        label:"青岛海尔保险代理有限公司",
        value:"1390"
    },
    {
        label:"青岛海尔保险代理有限公司青岛分公司",
        value:"0KR0"
    },
    {
        label:"青岛全掌柜科技有限公司",
        value:"0GH0"
    }
]

// 创客、V客 归属公司列表
export const ascriptionCompanyList = [
    "青岛海尔保险代理有限公司",
    "青岛海尔保险代理有限公司日照分公司",
    "青岛海尔保险代理有限公司德州分公司",
    "青岛海尔保险代理有限公司滨州分公司",
    "青岛海尔保险代理有限公司烟台分公司",
    "青岛海尔保险代理有限公司东营分公司",
    "青岛海尔保险代理有限公司临沂分公司",
    "青岛海尔保险代理有限公司济南分公司",
    "青岛海尔保险代理有限公司淄博分公司",
    "青岛海尔保险代理有限公司威海分公司",
    "青岛海尔保险代理有限公司青岛分公司",
    "青岛海尔保险代理有限公司石家庄分公司"
]

// 产品相关的产品节点
export const commonProductNodeList=[
    {value:"FINANCE",label:"企财节点"},
    {value:"HEALTH",label:"健康节点"},
    {value:"DUTY",label:"产责节点"},
    {value:"CHANNEL",label:"渠道节点"},
    {value:"CAR",label:"车险运营节点"},
    {value:"ECOLOGY",label:"金融生态节点"},
    {value:"OTHER",label:"其他节点"},
]

// 财务管理-佣金报酬相关的产品节点
export const commissionRemunerationNodeList=[
    {value:"FINANCE",label:"企财节点"},
    {value:"HEALTH",label:"健康节点"},
    {value:"DUTY",label:"产责节点"},
    {value:"CHANNEL",label:"渠道节点"},
    // {value:"CAR",label:"车险运营节点"},
    {value:"ECOLOGY",label:"金融生态节点"},
    // {value:"OTHER",label:"其他节点"},
]

// 财务管理-佣金报酬导入类型
export const commissionRemunerationImportTypeList=[
    {value:"CAR_COMMISSION",label:"车险佣金"},
    {value:"LIFE_NOT_ONLINE_COMMISSION",label:"部分寿险非在线佣金"},
    {value:"PRODUCT_COMMISSION",label:"产险佣金"}
]

// 审核流状态
export const commonAuditStatus={
    WAITING:"审核中",
    PASS:"审核通过",
    REJECT:"审核驳回"
}

//职级
export const levelList = [
    {
        label: 'V客',
        value: '0'
    },
    {
        label: '创客',
        value: '1'
    },
    {
        label: '营销经理',
        value: '14',
        children: [
            {label: '准营销经理', value: 'INTRODUCE'},
            {label: '营销经理', value: 'NORMAL'},
        ],
    },
    {
        label: '初级合伙人',
        value: '15',
        children: [
            {label: '准初级合伙人', value: 'INTRODUCE'},
            {label: '初级合伙人', value: 'NORMAL'}
        ]
    },
    {
        label: '中级合伙人',
        value: '16',
        children: [
            {label: '准中级合伙人', value: 'INTRODUCE'},
            {label: '中级合伙人', value: 'NORMAL'},
            {label: '中级合伙人（考察）', value: 'INSPECT'},
        ]
    },
    {
        label: '高级合伙人',
        value: '17',
        children: [
            {label: '准高级合伙人', value: 'INTRODUCE'},
            {label: '高级合伙人', value: 'NORMAL'},
            {label: '高级合伙人（考察）', value: 'INSPECT'},
        ]
    },
]

// 空调安装工产品
export const installerProductList=[
    {
        value:"2019",
        label:"2019年",
        children:[
            {value:"0",label:"产品1—按单保"},
            {value:"3",label:"产品2—按天保"},
            {value:"2",label:"产品3—按人保"},
            {value:"1",label:"产品4—按人+附加24小时"},
            {value:"4",label:"产品5—按人+附加24小时+不计免赔"},
            {value:"5",label:"产品6—按人+附加不计免赔"},
            {value:"6",label:"产品7—按人+20万死亡/伤残保额"},
            {value:"7",label:"产品8—按人+20万死亡/伤残保额+附加24小时"},
            {value:"8",label:"产品9—按人+20万死亡/伤残保额+附加24小时+不计免赔"},
            {value:"9",label:"产品10—按人+20万死亡/伤残保额+不计免赔"},
            {value:"10",label:"产品11-按单保+20万死亡/伤残保额"}
        ]
    },
    {
        value:"2020",
        label:"2020年",
        children:[
            {value:"14",label:"产品1-按人保-基础款-400积分/人/年"},
            {value:"15",label:"产品2-按人保-保障款-498积分/人/年"},
            {value:"16",label:"产品3-按人保-升级版-650积分/人/年"},
            {value:"17",label:"产品4-按人保-高端款-750积分/人/年"},
            {value:"18",label:"产品5-按人保-土豪款-1480积分/人/年"},
            {value:"12",label:"产品6-按工单保-100万保额基础款"},
            {value:"13",label:"产品7-按工单保-120万保额升级款"},
            {value:"19",label:"产品8-完工责任险-1200元/网点/年"},
            {value:"20",label:"产品9-按人保-950元/人/年"},
            {value:"21",label:"产品10-按人保-1100元/人/年"},
        ]
    }
]

/**工号维护 保险公司 */
export const insuranceCompanyList = [
    {
        value: 'TIAN_AN_LIFE',
        label: '天安人寿',
    },{
        value: 'XIN_TAI',
        label: '信泰人寿',
    },{
        value: 'GREAT_LIFE',
        label: '长城人寿',
    },{
        value: 'HENG_AN_SL',
        label: '恒安标准'
    },{
        value: 'HUA_LIFE',
        label: '华夏人寿'
    },{
        value: 'SINOSIG_LIFE',
        label: '阳光人寿'
    },{
        value: 'BOHAI_LIFE',
        label: '渤海人寿'
    },{
        value: 'AEON_LIFE',
        label: '百年人寿'
    },{
        value: 'ERGO_LIFE',
        label: '德华安顾'
    }
]

/**理赔管理--服务工单品类 */
export const workOrders = [
    {value: '空调',label: '空调'},
    {value: '冰箱',label: '冰箱'},
    {value: '冷柜',label: '冷柜'},
    {value: '洗衣机',label: '洗衣机'},
    {value: '燃气热水器',label: '燃气热水器'},
    {value: '电热水器',label: '电热水器'},
    {value: '热泵热水器',label: '热泵热水器'},
    {value: '油烟机',label: '油烟机'},
    {value: '燃气灶',label: '燃气灶'},
    {value: '电视',label: '电视'},
    {value: '其他',label: '其他'},
]

/**佣金结算-新 保单状态查询条件 */
export const commissionPolicyStatus =  [
    {value: '1',label: '未完成'},
    {value: '2',label: '承保件'},
    {value: '3',label: '预收件'},
    {value: '4',label: '犹退件'},
    {value: '5',label: '停效件'},
    {value: '6',label: '失效件'},
    {value: '7',label: '终止件'},
    {value: '10',label: '宽限件'},
    {value: '11',label: '豁免件'},
    {value: '13',label: '退保件'}
]

// 保单管理-保单状态
export const policyStatus=[
    {value: '1',label: '未完成'},
    {value: '3',label: '预收'},
    {value: '2',label: '承保'},
    {value: '4',label: '犹退'},
    {value: '5',label: '停效'},
    {value: '6',label: '失效'},
    {value: '7',label: '终止'},
    {value: '10',label: '宽限'},
    {value: '11',label: '豁免'},
    {value: '13',label: '退保'}
]
// 保单管理-保单产品状态
export const policyProductStatus=[
    {value:'UNDONE',key:'1',label:"未完成"},
    {value:'CHENGBAOJIAN',key:'2',label:"承保"},
    {value:'YUSHOUJIAN',key:'3',label:"预收"},
    {value:'QICHEJIAN',key:'4',label:"犹退"},
    {value:'TINGXIAOJIAN',key:'5',label:"停效"},
    {value:'SHIXIAOJIAN',key:'6',label:"失效"},
    {value:'ZHONGZHIJIAN',key:'7',label:"终止"},
    {value:'XINBAO',key:'8',label:"新保"},
    {value:'XUBAO',key:'9',label:"续保"},
    {value:'KUANXIANJIAN',key:'10',label:"宽限"},
    {value:'HUOMIANJIAN',key:'11',label:"豁免"},
    {value:'YUTUIJIAN',key:'12',label:"逾退"},
    {value:'TUIBAOJIAN',key:'13',label:"退保"},
    {value:'CHECK_FAIL',key:'14',label:"核保未通过"},
    {value:'REMOVED_PARTS',key:'15',label:"已撤"},
    {value:'JUBAO',key:'16',label:"拒保"},
]

// 货物或应税劳务、服务名称
export const invoiceItemTypeList = [
    {value: 'ECONOMIC_AGENCY_SERVICE',label: '经纪代理服务'},
    {value: 'IT_SERVICE',label: '信息技术服务'},
    {value: 'OTHER_DESIGN_SERVICE',label: '其他设计服务'},
    {value: 'OTHER_AD_PUBLISH_SERVICE',label: '其他广告发布服务'},
]

// 身份证类型
export const certificate = [[
	{
		name:'身份证',
		value: '1'
	},{
		name: '护照',
		value: '2'
	},{
		name: '军官证',
		value: '3'
	},{
		name: '港澳通行证',
		value: '9'
	}
]]

//产品对比管理与计划书管理分类
export const suiteTypes = [
    {label:'重疾',value:'SICKNESS'},
    {label:'医疗',value:'MEDICAL'},
    {label:'意外',value:'ACCIDENT'},
    {label:'人寿',value:'LIFE'},
    {label:'年金',value:'ANNUITY'},
    {label:'其他',value:'OTHER'}
]

//海尔生态-客户管理-企业行业分类
export const industryType = [
    {value:'A',label:'农、林、牧、渔业'},
    {value:'B',label:'采矿业'},
    {value:'C',label:'制造业'},
    {value:'D',label:'电力、热力、燃气及水生产和供应业'},
    {value:'E',label:'建筑业'},
    {value:'F',label:'批发和零售业'},
    {value:'G',label:'交通运输、仓储和邮政业'},
    {value:'H',label:'住宿和餐饮业'},
    {value:'I',label:'信息传输、计算机服务和软件业'},
    {value:'J',label:'金融业'},
    {value:'K',label:'房地产业'},
    {value:'L',label:'租凭和商务服务业'},
    {value:'M',label:'科学研究、技术服务和地质勘查业'},
    {value:'N',label:'水利、环境和公共设施管理业'},
    {value:'O',label:'居民服务和其他服务业'},
    {value:'P',label:'教育'},
    {value:'Q',label:'卫生、社会工作'},
    {value:'R',label:'文化、体育、娱乐业'},
    {value:'S',label:'公共管理、社会保障与社会组织'},
    {value:'T',label:'国际组织'}
]

//海尔生态-老保代产品名对应productCode
export const oldInsuranceList = [
    {value:'OLD_INSURANCE_PROXY_SPECIAL_THIRD',label:'特种设备第三者责任险'},
    {value:'OLD_INSURANCE_PROXY_BUSINESS_PROPERTY',label:'企业财产险'},
    {value:'OLD_INSURANCE_PROXY_MACHINE_DAMAGE',label:'机器损坏险'},
    {value:'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_INLAND',label:'国内产品责任险'},
    {value:'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_FOREIGN',label:'海外产品责任险'},
    {value:'OLD_INSURANCE_PROXY_OVERSEAS_TRAVELERS',label:'境外旅行人身意外伤害险'},
    {value:'OLD_INSURANCE_PROXY_YACHT',label:'游艇险'},
]

//海尔生态-老保代附件类型
export const oldInsuranceFlieTypeList = [
    {value:'APPLICATION',label:'投保单'},
    {value:'APPLICATION_COMFIRM',label:'投保确认书'},
    {value:'STATEMENTS',label:'内结单'},
    {value:'POLICY',label:'保单'},
    {value:'INVOICE',label:'发票'},
    {value:'ENDORSE',label:'批改单'},
    {value:'ENDORSE_POLICY',label:'批改保单'},
    {value:'FEE_INVOICE',label:'佣金发票'},
    {value:'OTHER',label:'其他附件'},
]

//国寿企业雇主责任险行业分类
export const gsIndustryType = [
    {value:'A',label:'A-农、林、牧、渔业'},
    {value:'B',label:'B-采矿业'},
    {value:'C',label:'C-制造业'},
    {value:'D',label:'D-电力、热力、燃气及水生产和供应业'},
    {value:'E',label:'E-建筑业'},
    {value:'F',label:'F-批发和零售业'},
    {value:'G',label:'G-交通运输、仓储和邮政业'},
    {value:'H',label:'H-住宿和餐饮业'},
    {value:'I',label:'I-信息传输、软件和信息技术服务业'},
    {value:'J',label:'J-金融业'},
    {value:'K',label:'K-房地产业'},
    {value:'L',label:'L-租赁和商务服务业'},
    {value:'M',label:'M-科学研究和技术服务业'},
    {value:'N',label:'N-水利、环境和公共设施管理业'},
    {value:'O',label:'O-居民服务、修理和其他服务业'},
    {value:'P',label:'P-教育'},
    {value:'Q',label:'Q-卫生和社会工作'},
    {value:'R',label:'R-文化、体育和娱乐业'},
    {value:'S',label:'S-公共管理、社会保障和社会组织'},
    {value:'T',label:'T-国际组织'}
]

//国寿企业雇主责任险企业性质
export const gsCompany = [
    {value:'STATE_ORGANS',label:'国家机关'},
    {value:'PUBLIC_INSTITUTIONS',label:'事业单位'},
    {value:'SOCIAL_GROUPS',label:'社会团体'},
    {value:'SCHOOL',label:'学校'},
    {value:'ENTERPRISE',label:'企业'},
    {value:'INDIVIDUAL_BUSINESS',label:'个体工商户'}
]


// WEBPACK FOOTER //
// ./src/common/dictionary.js